import {connect} from 'react-redux';
import PageTitle from './PageTitle';

const mapStateToProps = ({
                           nextStep: {nextStep, currentUserStepNumber, totalSteps},
                           user: {firstName},
                           specificStep
                         }) => ({
  nextStep,
  currentUserStepNumber,
  totalSteps,
  firstName,
  specificStep
});

export default connect(
  mapStateToProps,
  null
)(PageTitle);
